import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import ResultsFromGoogleImage from "assets/images/results-from-google.svg";
import { PlainButton } from "components/button/plain";
import ClearIconAsset from "assets/images/icons/close-light.svg";

export const Component = styled("div", { label: "autocomplete" })`
  flex: 1;
  position: relative;
`;

export const Loading = styled(CircularProgress, { label: "loading" })`
  width: 1.25rem !important;
  height: 1.25rem !important;
`;

export const ClearIcon = styled(ClearIconAsset, { label: "clear-icon" })`
  fill: currentColor;
  width: ${({ theme }) => theme.spacing(1.5)};
  height: auto;
`;

export const Footer = styled("div", { label: "footer" })`
  align-items: flex-end;
  display: flex;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
  padding: ${({ theme }) => theme.spacing(1.5)};
`;

export const FullAddressTrigger = styled(PlainButton, {
  label: "full-address-trigger",
})`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Option = styled("li", { label: "option" })`
  &&.${autocompleteClasses.focused} {
    background-color: ${({ theme }) => theme.palette.color.primary[95]};
  }
`;

export const ResultsFromGoogle = styled(ResultsFromGoogleImage, {
  label: "results-from-google",
})`
  fill: ${({ theme }) => theme.palette.color.gray[70]};
  flex: 0 0 auto;
  margin: 0.1em 0 0 auto;
  width: auto;
  height: 1.1em;
`;
